import React, {Component} from 'react';
import {RegularCard} from "cw-styleguide-react";
import {route} from "../routes";
import {withTranslation} from "react-i18next";
class JobThinkCard extends Component {

  render() {
    return (
      <RegularCard
        width={33}
        link={{
          to: '/' + this.props.slug +  route('think')
        }}
        alt={''}
        source={this.props.data.thinkAboutImage}
        title={this.props.data.thinkAboutStatic}
      />
    )
  }

}

export default withTranslation('local')(JobThinkCard);
